<template>
    <ul class="product-aside">
        <li 
            class="product-aside-wrap"
            v-for="(item, index) in productCategory" 
            :key="index"
        >
            <div 
                class="product-aside-title pl-4 d-flex justify-content-between" 
                v-b-toggle="item.id"
            >
                <p>{{item.name}}</p>
                <BgIcon icon="caret-right" color="#bcbcbc" borderColor="#bcbcbc" size="lg" bgSize="sm" :class="{iconActive :visible[index]}" />
            </div>
            
            <b-collapse 
                class="pl-5"
                :id="item.id" 
                :visible="visible[index]"
                accordion="productCategory-accordion"
                tag="ul"
                @show="collapseShow(index)"
                @hide="collapseHide(index)"

            >
                    <li 
                        class="product-aside-item"
                        v-for="(item, index) in item.items" :key="index">
                        <router-link :to="item.to">●  {{item.name}}</router-link>
                    </li>
            </b-collapse>

        </li>
    </ul>
</template>

<script>
import BgIcon from "@/components/BgIcon"

export default {
    props:['productCategory'],
    components: { BgIcon },
    data() {
        return {
            visible: [],
        }
    },
    watch: {
        '$route': {
            handler(v) {
                this.visibleHandle()
            }
        },
        'immediate': true
    },
    created() {
        this.visibleHandle()
    },
    methods: {
        visibleHandle() {
            this.visible = this.productCategory.map(category => {
                return category.items.find( item => item.to.params.name == this.$route.params.name)
                    ? true
                    : false
            })
        },
        collapseShow(index) {
                this.visible = this.visible.map((v, i) => i == index ? true : false)
        },
        collapseHide(index) {
            this.$set(this.visible, index, false)
        }
    },
}
</script>

<style lang="scss">
    .product-aside{
        &-title {
            cursor: pointer;
            p{
                margin-bottom: 0;
                font: {
                    size: 16px;
                    weight: bold
                };
            }
        }
        &-wrap {
            margin: 8px 0;
            padding: 5px;
            background-color: $color-light;
        }
        &-item{
            a{
                display: block;
                padding: 0;
                line-height: 2;
                transition: all 0.3s;
                &:hover{
                    padding-left: 10px
                }
                &.router-link-active{
                    color: $color-main;
                    font-weight: bold;
                }
            }
        }
        .icon {
            padding-left: 3px;
            transition: all 0.3s;
        }
    }
    .iconActive {
        transform: rotate(90deg);
        transition: all 0.3s;
    }
</style>